<prism-dialog
	*transloco="let t; prefix: 'scDiscoveryErrorDialog'"
	class="sh-dialog-container sh-discovery-error-dialog-container"
	fxLayout="column"
	[visible]="true"
>
	<span slot="dialog-title" class="sh-discovery-error-title">
		{{ t('discovery-error-dialog-title') }}
	</span>
	<div class="sh-dialog-content" fxLayout="column" fxLayoutAlign="start">
		<h4 class="sh-discovery-error-title">
			{{ t('discovery-error-dialog-try') }}
		</h4>
		<ul class="sh-dialog-ul">
			<li>{{ t('discovery-error-dialog-content') }}</li>
		</ul>
	</div>
	<div class="sh-dialog-content" fxLayout="column" fxLayoutAlign="start">
		<h4 class="sh-discovery-error-title">
			{{ t('discovery-error-dialog-support') }}
		</h4>
	</div>

	<div slot="dialog-footer-buttons">
		<prism-button id="sh-discovery-error-close-button" color="accent" (click)="close()">
			{{ t('close') }}
		</prism-button>
	</div>
</prism-dialog>
